import { render } from "./NTabItem.vue?vue&type=template&id=6b9192de&ts=true"
import script from "./NTabItem.vue?vue&type=script&lang=ts"
export * from "./NTabItem.vue?vue&type=script&lang=ts"

import "./NTabItem.vue?vue&type=style&index=0&id=6b9192de&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__